<template>
	<main
		class="p-5 xl:px-32 md:pt-24 place-items-stretch min-h-screen bg-gradient-to-b from-gray-900 via-purple-900 to-purple-800">
		<h1
			class="text-4xl sm:text-5xl md:text-7xl text-center md:text-left font-bold text-gray-200">
			Our Services
		</h1>
		<div class="mt-8 mx-auto">
			<div
				class="w-full flex md:flex-row md:flex-wrap flex-col justify-between justofy-items-center">
				<div class="py-4 xl:pr-4 xl:w-1/3">
					<div
						class="h-full rounded-xl shadow-cla-blue bg-gradient-to-r from-indigo-50 to-blue-50 overflow-hidden">
						<img
							class="lg:h-48 md:h-36 w-full object-cover object-center scale-110 transition-all duration-400 hover:scale-100"
							src="https://images.unsplash.com/photo-1618172193622-ae2d025f4032?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1064&q=80"
							alt="blog" />
						<div class="p-6 flex w-full justify-between items-center">
							<h1 class="title-font text-lg font-medium text-gray-600">
								Instruments
							</h1>
							<div class="flex items-center flex-wrap">
								<router-link
									to="/instruments"
									class="bg-gradient-to-r from-cyan-400 to-blue-400 hover:scale-105 drop-shadow-md shadow-cla-blue px-4 py-1 rounded-lg">
									Learn more
								</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="py-4 xl:px-4 xl:w-1/3">
					<div
						class="h-full rounded-xl shadow-cla-violate bg-gradient-to-r from-pink-50 to-red-50 overflow-hidden">
						<img
							class="lg:h-48 md:h-36 w-full object-cover object-center scale-110 transition-all duration-400 hover:scale-100"
							src="https://images.unsplash.com/photo-1624628639856-100bf817fd35?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8M2QlMjBpbWFnZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60"
							alt="blog" />
						<div class="p-6 flex w-full justify-between items-center">
							<h1 class="title-font text-lg font-medium text-gray-600">
								Black Books
							</h1>
							<div class="flex items-center flex-wrap">
								<router-link
									to="/blackbooks"
									class="bg-gradient-to-r from-cyan-400 to-blue-400 hover:scale-105 drop-shadow-md shadow-cla-blue px-4 py-1 rounded-lg">
									Learn more
								</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="py-4 xl:pl-4 xl:w-1/3">
					<div
						class="h-full rounded-xl shadow-cla-pink bg-gradient-to-r from-white to-pink-100 overflow-hidden">
						<img
							class="lg:h-48 md:h-36 w-full object-cover object-center scale-110 transition-all duration-400 hover:scale-100"
							src="https://images.unsplash.com/photo-1618172193622-ae2d025f4032?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1064&q=80"
							alt="blog" />
						<div class="p-6 flex w-full justify-between items-center">
							<h1 class="title-font text-lg font-medium text-gray-600">
								PYQ Papers
							</h1>
							<div class="flex items-center flex-wrap">
								<router-link
									to="/pyqpapers"
									class="bg-gradient-to-r from-cyan-400 to-blue-400 hover:scale-105 drop-shadow-md shadow-cla-blue px-4 py-1 rounded-lg">
									Learn more
								</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="flex-grow"></div>
			</div>
		</div>
	</main>
</template>
<script>
export default {
	name: 'Services'
}
</script>